import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/ImageScroller/ImageScroller.js
const ImageScroller = createSectionForm({
  icon: "gallery-line",
  title: "Image Scroller",
  fields: [
    { name: "title", label: "Title" },
    { name: "description", label: "Description", type: "richtext" },
    {
      name: "images",
      label: "Images",
      type: "list",
      itemLabel: "Image",
      fields: [{ name: "image", label: "Image", type: "media" }],
    },
  ],
});

export default ImageScroller;
